module.exports = __webpack_public_path__ + "assets/logo_sq_white-871205.svg";